import axios from 'axios';

import { IResearcher } from '@/shared/model/researcher.model';

const baseApiUrl = 'api/researchers';
const baseApiUrlOrdered = 'api/researchers-ordered';
const apiFindResearcher = 'api/researchers/find';

export default class ResearcherService {
  public find(id: number): Promise<IResearcher> {
    return new Promise<IResearcher>((resolve, reject) => {
      axios
        .get(`${apiFindResearcher}/${id}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retrieve(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public create(entity: IResearcher): Promise<IResearcher> {
    return new Promise<IResearcher>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public update(entity: IResearcher): Promise<IResearcher> {
    return new Promise<IResearcher>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retrieveOrdered(lang: string, instid: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`${baseApiUrlOrdered}/${lang}/${instid}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
